<script setup lang="ts">
import type { Attr } from "~/types";
import { SekouSearchAttrs } from "#components";
import { useModal } from "vue-final-modal";
const attrs = inject<Attr[]>("attrs", []);

// 詳しく絞り込むモーダル定義
const { open, close } = useModal({
  component: SekouSearchAttrs,
  attrs: {
    attrs,
    onClose: () => {
      close();
    },
  },
});

const isShow = ref(false);

function showButton() {
  if (100 <= window.scrollY) {
    isShow.value = true;
  } else {
    isShow.value = false;
  }
}

onMounted(() => {
  window.addEventListener("scroll", showButton, { passive: true });
});
</script>

<template>
  <Transition name="slide-fade-r">
    <button v-show="isShow" class="button" @click="open">
      <Icon class="text-white" size="24" name="mdi:filter" />
    </button>
  </Transition>
</template>

<style scoped>
/* TODO:一番上に戻るボタンがないときに位置を調整する */
.button {
  @apply flex items-center justify-center z-10 bg-[#0061FE] hover:bg-[#0061fec3] fixed bottom-20 right-4 rounded-full aspect-square cursor-pointer w-12;
}
</style>
